import React from 'react';
import { InputField } from 'components/Global';

const DetailPemesanan = ({ data, selectedCountry }) => {
  return (
    data?.order_detail?.is_for_other_person && (
      <div className="detail-order-airport__renter-detail">
        <div className="detail-order-airport__renter-detail-title">
          <h1>Detail Pemesan</h1>
        </div>
        <div className="detail-order-airport__renter-detail-body">
          <InputField label="Nama Lengkap" disabled value={data?.order_detail?.other_person_name || '-'} />
          <InputField label="Email" disabled value={data?.order_detail?.other_person_email || '-'} />

          <div className="detail-order-airport__renter-detail-body__phone-number">
            <InputField
              label="No Handphone"
              disabled
              value={data?.order_detail?.other_person_phone_cc || '-'}
              icon={
                <img
                  src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                  width={26}
                  height={16}
                  alt={selectedCountry?.name + ' nation flag'}
                />
              }
            />
            <InputField value={data?.order_detail?.other_person_phone || '-'} disabled />
          </div>
        </div>
      </div>
    )
  );
};

export default DetailPemesanan;
